import React from 'react';
import ReactDOM from 'react-dom';
import { act } from 'react-dom/test-utils';

// heic2any が jsdom(Worker 無し) で import 時に落ちるためモックする。
// 画像正規化自体は normalize_image.test.js で保証済み。
jest.mock('./normalize_image', () => jest.fn());

// eslint-disable-next-line import/first
import IdentificationWizard from './IdentificationWizard';

// 撮影 input の capture 属性を保証する。
// 身分証(表・裏)はカメラ撮影(capture=environment)とフォルダ選択(capture無し)の2ボタン構成、
// セルフィーはカメラ限定(capture=user、偽装対策)。

describe('IdentificationWizard file inputs', () => {
  let container;

  beforeEach(() => {
    container = document.createElement('div');
    document.body.appendChild(container);
    act(() => {
      ReactDOM.render(
        <IdentificationWizard
          rulesUrl="https://example.com/rules"
          privacyPolicyUrl="https://example.com/privacy"
          homeUrl="/"
        />,
        container,
      );
    });
  });

  afterEach(() => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  });

  it('身分証(表・裏)はカメラ/フォルダ両対応、セルフィーは前面カメラのみ', () => {
    const inputs = container.querySelectorAll('input[type="file"]');
    // frontCamera / frontLibrary / backCamera / backLibrary / selfie の5つ
    expect(inputs).toHaveLength(5);
    const captures = Array.from(inputs).map((input) => input.getAttribute('capture'));
    expect(captures).toEqual(['environment', null, 'environment', null, 'user']);
  });

  it('全ての撮影 input が画像のみ受け付ける', () => {
    const inputs = container.querySelectorAll('input[type="file"]');
    Array.from(inputs).forEach((input) => {
      expect(input.getAttribute('accept')).toBe('image/*');
    });
  });

  // ガイド画面のボタン構成: 並列な2択（カメラ/フォルダ）を同格で縦に並べ、
  // 「戻る」はテキストリンクとして最下段。戻るで書類選択前（entry）に戻れる。
  it('ガイド画面はカメラ/フォルダの2択＋戻るリンクで、戻るで entry に戻る', () => {
    // 装飾 span（書類選択の「›」等）を含むボタンも拾えるよう部分一致
    const clickByText = (text) => {
      const button = Array.from(container.querySelectorAll('button')).find(
        (el) => el.textContent.includes(text),
      );
      expect(button).toBeTruthy();
      act(() => {
        button.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      });
    };

    clickByText('同意して撮影を開始する');
    clickByText('運転免許証／運転経歴証明書');

    const guideButtons = Array.from(container.querySelectorAll('button')).map(
      (el) => el.textContent,
    );
    expect(guideButtons).toEqual(
      expect.arrayContaining(['同意してカメラで撮影', '同意してフォルダから選択', '戻る']),
    );

    clickByText('戻る');
    expect(
      Array.from(container.querySelectorAll('button')).some(
        (el) => el.textContent === '同意して撮影を開始する',
      ),
    ).toBe(true);
  });
});
